import { Badge } from "@chakra-ui/react";
import { ReactElement, ReactNode } from "react";
import { SIDEBAR_ANIMATION_DURATION, SIDEBAR_WIDTH } from "./PageLayout/base";

export type MotdStatus = "warning" | "error";

interface MotdBannerProps {
  text?: string | null;
  status?: MotdStatus | null;
  children: ReactNode;
}

export default function MotdBanner(props: MotdBannerProps): ReactElement {
  const { text, status = "warning", children } = props;

  return (
    <>
      {text != null && (
        <Badge
          colorScheme={status === "error" ? "red" : "orange"}
          w="full"
          maxW="full"
          h="12"
          textTransform="none"
          fontSize="md"
          display="flex"
          flexWrap="wrap"
          whiteSpace="wrap"
          textAlign="center"
          alignItems="center"
          justifyContent="center"
          zIndex={1199}
          transitionProperty="padding-left"
          transitionDuration={SIDEBAR_ANIMATION_DURATION}
          css={{
            ":has(+ * .crt-sidebar-open)": { "padding-left": SIDEBAR_WIDTH },
          }}
        >
          {text}
        </Badge>
      )}
      {children}
    </>
  );
}
